import Swiper from 'swiper';

let viewportWidth = document.documentElement.clientWidth;
const containerSlider = $('.js-slider-brands');

function initBrands() {
  containerSlider.find('.btn-slide--prev').addClass('prev-brand');
  containerSlider.find('.btn-slide--next').addClass('next-brand');

  let multirow = 4;

  if (containerSlider.find('.swiper-slide').length < 7) {
    $('.slider-brands__controls').hide();
    multirow = 'auto';
  }

  if (viewportWidth > 1819) {
    multirow = 'none';
  }

  new Swiper('.js-slider-brands.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.slider-brands__count',
      type: 'fraction'
    },
    navigation: {
      nextEl: '.next-brand',
      prevEl: '.prev-brand'
    },
    breakpointsInverse: true,
    breakpoints: {
      280: {
        freeMode: true,
        slidesPerView: 'auto'
      },
      768: {
        slidesPerView: 4,
        slidesPerColumn: multirow,
        spaceBetween: 20
      },
      1024: {
        slidesPerColumn: 3,
        slidesPerView: 2,
        spaceBetween: 20
      },
      1820: {
        slidesPerView: 4,
        slidesPerColumn: multirow,
        spaceBetween: 20
      }
    }
  });
}

if (containerSlider.length) {
  initBrands();
}

$(window).resize(function () {
  viewportWidth = document.documentElement.clientWidth;
  initBrands();
});